// only very generic components should be in here
import ActionsRenderer from './ActionsRenderer';
import ButtonRenderer from './ButtonRenderer';

export default {
  buttonRenderer: ButtonRenderer,
  actionsRenderer: ActionsRenderer,
};
